import { useCallback } from 'react';
import { useNavigate, NavigateOptions, To } from 'react-router';
import { useOrgStore } from '@/stores/org-store';

/**
 * Wraps useNavigate() to automatically prepend `/o/{orgId}` to paths.
 * Supports string paths, numbers (history), and object form { pathname, search }.
 */
export const useOrgNavigate = () => {
  const navigate = useNavigate();
  const currentOrg = useOrgStore((s) => s.currentOrg);

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      if (typeof to === 'string') {
        if (to.startsWith('/') && !to.startsWith('/o/') && currentOrg?.orgid) {
          navigate(`/o/${currentOrg.orgid}${to}`, options);
        } else {
          navigate(to, options);
        }
        return;
      }

      // Object form: { pathname, search, hash }
      if (
        to.pathname?.startsWith('/') &&
        !to.pathname.startsWith('/o/') &&
        currentOrg?.orgid
      ) {
        navigate(
          { ...to, pathname: `/o/${currentOrg.orgid}${to.pathname}` },
          options,
        );
      } else {
        navigate(to, options);
      }
    },
    [navigate, currentOrg?.orgid],
  );
};
